/**
 * WINDSURF ADD TO CART FIX
 * Universal solution that works with any theme template
 * Overrides all existing Add to Cart buttons
 */

console.log('🚀 WINDSURF: Loading universal Add to Cart fix...');

// Wait for page to load
document.addEventListener('DOMContentLoaded', function() {
  console.log('🔧 WINDSURF: DOM loaded, initializing fix...');
  
  // Find all potential Add to Cart buttons with improved detection
  let buttons = [];
  
  // Method 1: Find all buttons and check their text content
  const allButtons = document.querySelectorAll('button, input[type="submit"], input[type="button"], a');
  console.log('🔍 WINDSURF: Checking', allButtons.length, 'total buttons/links');
  
  allButtons.forEach((btn, index) => {
    const text = btn.textContent || btn.value || btn.innerText || '';
    const lowerText = text.toLowerCase().trim();
    
    if (lowerText.includes('add to cart') || 
        lowerText.includes('add to bag') ||
        lowerText.includes('addtocart') ||
        btn.name === 'add' ||
        btn.hasAttribute('data-btn-addtocart') ||
        btn.hasAttribute('data-add-to-cart') ||
        btn.classList.contains('btn-addtocart') ||
        btn.classList.contains('add-to-cart') ||
        btn.classList.contains('addtocart')) {
      
      console.log('✅ WINDSURF: Found Add to Cart button:', btn);
      buttons.push(btn);
    }
  });
  
  // Method 2: Specific selectors as fallback
  const specificSelectors = [
    'button[name="add"]',
    '[data-btn-addtocart]',
    'input[name="add"]',
    '.btn-addtocart',
    '.add-to-cart',
    '.addtocart',
    'form[action*="/cart/add"] button',
    'form[action*="/cart/add"] input[type="submit"]'
  ];
  
  specificSelectors.forEach(selector => {
    try {
      const found = document.querySelectorAll(selector);
      found.forEach(btn => {
        if (!buttons.includes(btn)) {
          console.log('✅ WINDSURF: Found via selector', selector, ':', btn);
          buttons.push(btn);
        }
      });
    } catch(e) {
      console.log('⚠️ WINDSURF: Invalid selector:', selector);
    }
  });
  
  console.log('🔍 WINDSURF: Found Add to Cart buttons:', buttons.length);
  
  buttons.forEach((button, index) => {
    console.log(`🎯 WINDSURF: Processing button ${index + 1}:`, button);
    
    // Remove existing event listeners
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
    
    // Add our click handler with multiple methods
    console.log('🔧 WINDSURF: Adding click handler to button:', newButton);
    
    // Method 1: addEventListener
    newButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('🚀 WINDSURF: Add to Cart clicked via addEventListener!');
      handleAddToCart(newButton);
    });
    
    // Method 2: onclick property (fallback)
    newButton.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('🚀 WINDSURF: Add to Cart clicked via onclick!');
      handleAddToCart(newButton);
      return false;
    };
    
    // Method 3: Add test click detection
    newButton.addEventListener('mousedown', function() {
      console.log('🖱️ WINDSURF: Button mousedown detected');
    });
    
    newButton.addEventListener('mouseup', function() {
      console.log('🖱️ WINDSURF: Button mouseup detected');
    });
  });
  
  // Separate function to handle add to cart
  function handleAddToCart(button) {
    // Prevent double-clicks
    if (button.dataset.isProcessing === 'true') {
      console.log('🛑 WINDSURF: Button already processing, preventing duplicate click');
      return;
    }
    
    // Mark button as processing
    button.dataset.isProcessing = 'true';
    
    console.log('🎯 WINDSURF: handleAddToCart called for button:', button);
      
    // Find variant ID
    let variantId = null;
    
    // Method 1: Look for hidden input with name="id"
    const form = button.closest('form');
    if (form) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantId = variantInput.value;
      }
    }
    
    // Method 2: Look for data attributes on button
    if (!variantId) {
      variantId = button.dataset.variantId || 
                 button.dataset.productVariantId ||
                 button.dataset.addToCart;
    }
    
    // Method 3: Look for variant ID anywhere on page
    if (!variantId) {
      const variantElements = document.querySelectorAll('[data-variant-id], [data-product-variant-id], [data-variant], input[name="id"], select[name="id"]');
      variantElements.forEach((el) => {
        if (!variantId && (el.value || el.dataset.variantId || el.dataset.productVariantId)) {
          variantId = el.value || el.dataset.variantId || el.dataset.productVariantId;
        }
      });
    }
    
    // Method 4: Look in window/global variables (THIS IS WHAT WORKS!)
    if (!variantId) {
      if (window.meta && window.meta.product) {
        // Try multiple paths in meta.product
        variantId = window.meta.product.selected_or_first_available_variant?.id ||
                   window.meta.product.selected_variant?.id ||
                   window.meta.product.variants?.[0]?.id ||
                   window.meta.product.id;
                   
        // Fallback to variants array
        if (!variantId && window.meta.product.variants && window.meta.product.variants.length > 0) {
          variantId = window.meta.product.variants[0].id;
        }
      }
      
      if (!variantId && window.product) {
        variantId = window.product.selected_or_first_available_variant?.id || window.product.variants?.[0]?.id;
      }
    }
    
    // Method 5: Look for product JSON scripts
    if (!variantId) {
      const scripts = document.querySelectorAll('script[type="application/json"], script[data-product-json]');
      scripts.forEach((script) => {
        try {
          const data = JSON.parse(script.textContent);
          if (data.variants || data.selected_or_first_available_variant) {
            variantId = data.selected_or_first_available_variant?.id || data.variants?.[0]?.id;
          }
        } catch(e) {
          // Ignore parsing errors
        }
      });
    }
    
    // Method 6: Extract from URL parameters
    if (!variantId) {
      const urlParams = new URLSearchParams(window.location.search);
      variantId = urlParams.get('variant');
    }
    
    if (!variantId) {
      alert('Error: Could not find product variant ID');
      return;
    }
    
    // Update button state
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';
    button.style.opacity = '0.7';
    
    // Get the actual quantity from the form/input - CRITICAL FIX
    // Search in multiple places since the quantity input might be in different locations
    let quantity = 1;
    let quantityInput = null;
    
    // Try multiple selectors and locations
    const quantitySelectors = [
      'input[name="quantity"]',
      'select[name="quantity"]',
      '.quantity__input',
      '.quantity-input',
      '.qty-input',
      'quantity-input input[type="number"]',
      'quantity-input .quantity__input',
      '[data-quantity-input]',
      'input[type="number"][name="quantity"]',
      'cart-update-quantity input',
      'cart-update-quantity .quantity',
      'product-form input[name="quantity"]',
      'form input[name="quantity"]'
    ];
    
    // First try within the form
    if (form) {
      for (const selector of quantitySelectors) {
        quantityInput = form.querySelector(selector);
        if (quantityInput) {
          console.log('📊 WINDSURF: Found quantity input in form with selector:', selector);
          break;
        }
      }
    }
    
    // If not found in form, search the entire document (quantity might be outside form)
    if (!quantityInput) {
      // Try to find the product form first
      const productForm = document.querySelector('form[action*="/cart/add"], form.product-form, form[data-type="add-to-cart-form"], #product-form, .product-form');
      if (productForm) {
        for (const selector of quantitySelectors) {
          quantityInput = productForm.querySelector(selector);
          if (quantityInput) {
            console.log('📊 WINDSURF: Found quantity input in product form with selector:', selector);
            break;
          }
        }
      }
    }
    
    // If still not found, search the entire page
    if (!quantityInput) {
      for (const selector of quantitySelectors) {
        quantityInput = document.querySelector(selector);
        if (quantityInput && quantityInput.offsetParent !== null) { // Check if visible
          console.log('📊 WINDSURF: Found quantity input in document with selector:', selector);
          break;
        }
      }
    }
    
    // Get the quantity value
    if (quantityInput) {
      let qtyValue = quantityInput.value;
      // If value is empty, try other methods
      if (!qtyValue || qtyValue === '') {
        qtyValue = quantityInput.getAttribute('value') || 
                   quantityInput.textContent || 
                   quantityInput.dataset.quantity ||
                   '1';
      }
      quantity = parseInt(qtyValue, 10);
      if (isNaN(quantity) || quantity < 1) {
        quantity = 1;
      }
      console.log('📊 WINDSURF: Found quantity input:', {
        element: quantityInput,
        selector: quantitySelectors.find(s => {
          const test = document.querySelector(s);
          return test === quantityInput;
        }),
        value: quantityInput.value,
        attribute: quantityInput.getAttribute('value'),
        textContent: quantityInput.textContent,
        parsed: quantity
      });
    } else {
      console.warn('⚠️ WINDSURF: No quantity input found! Searched:', quantitySelectors);
    }
    
    // Also check for quantity in button data attributes
    if (quantity === 1 && button.dataset.quantity) {
      quantity = parseInt(button.dataset.quantity, 10) || 1;
      console.log('📊 WINDSURF: Using quantity from button data attribute:', quantity);
    }
    
    // Final quantity check - ensure it's a valid number
    if (isNaN(quantity) || quantity < 1) {
      console.warn('⚠️ WINDSURF: Invalid quantity detected, defaulting to 1. Original:', quantity);
      quantity = 1;
    }
    
    // Add to cart with the ACTUAL quantity from the form
    const data = {
      id: variantId,
      quantity: quantity
    };
    
    console.log('📤 WINDSURF: Sending to cart:', data);
    console.log('📤 WINDSURF: Quantity breakdown:', {
      fromInput: quantityInput ? quantityInput.value : 'no input found',
      finalQuantity: quantity,
      variantId: variantId
    });
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      console.log('📥 WINDSURF: Response status:', response.status, response.statusText);
      console.log('📥 WINDSURF: Response ok:', response.ok);
      
      if (!response.ok) {
        // Try to get error message from response
        return response.text().then(text => {
          console.error('❌ WINDSURF: Server error response:', text);
          let errorData;
          try {
            errorData = JSON.parse(text);
          } catch (e) {
            errorData = { message: text || 'Server error: ' + response.status };
          }
          throw new Error(errorData.description || errorData.message || 'Server error: ' + response.status);
        });
      }
      
      // Check if response has content
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        return response.json();
      } else {
        // If not JSON, try to parse as text first
        return response.text().then(text => {
          console.log('📥 WINDSURF: Response text:', text);
          try {
            return JSON.parse(text);
          } catch (e) {
            console.error('❌ WINDSURF: Failed to parse response as JSON:', e);
            throw new Error('Invalid response format from server');
          }
        });
      }
    })
    .then(result => {
      console.log('✅ WINDSURF: Added to cart:', result);
      
      // Update button
      button.textContent = 'Added!';
      button.style.backgroundColor = '#28a745';
        
        // Update cart count
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            console.log('🛒 WINDSURF: Cart updated:', cart.item_count, 'items');
            
            // Update cart count elements
            document.querySelectorAll('[data-cart-count]').forEach(el => {
              el.textContent = cart.item_count;
            });
            
            // Try to open cart drawer
            if (window.quick_cart && window.quick_cart.show) {
              document.body.classList.add('cart-sidebar-show');
              if (window.scoder && window.scoder.updateSidebarCart) {
                window.scoder.updateSidebarCart(cart);
              }
            }
          });
        
        // Reset button after 2 seconds
        setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
          button.style.opacity = '1';
          button.style.backgroundColor = '';
          button.dataset.isProcessing = 'false';
        }, 2000);
    })
    .catch(error => {
      console.error('❌ WINDSURF: Error:', error);
      
      // Don't show alert for duplicate request errors
      if (error && error.message && error.message.includes('Duplicate')) {
        console.log('🛑 WINDSURF: Duplicate request prevented - silently handling');
        button.disabled = false;
        button.textContent = originalText;
        button.style.opacity = '1';
        return; // Exit early, don't show error
      }
      
      button.disabled = false;
      button.textContent = originalText;
      button.style.opacity = '1';
      button.dataset.isProcessing = 'false';
      // Only show alert for real errors, not duplicate prevention
      if (error.message && !error.message.includes('Duplicate')) {
        alert('Error adding to cart: ' + error.message);
      }
    });
  }
  
  console.log('✅ WINDSURF: Universal Add to Cart fix applied to', buttons.length, 'buttons');
});

// Also try after a delay in case content loads dynamically
setTimeout(() => {
  console.log('🔄 WINDSURF: Re-running fix after delay...');
  document.dispatchEvent(new Event('DOMContentLoaded'));
}, 2000);
